import React from "react";
import VideoAndAssistance from "./VideoAndAssistance";

const Soccer13Rules = () => {
  return (
    <div>
      <VideoAndAssistance videoId="XXFy03Y6rJc" />
      <h2>Key Soccer 13 Information</h2>
      <p>Soccer 13 is similar to Soccer 10, but there are 13 matches instead of 10 and the payouts can be life changing. Here are the basic details:</p>
      <p>
        Soccer 13 is operated by TAB in conjunction with Svenska Spel Sweden. Please note Soccer 13 is hosted by Svenska Spel in Sweden and their rules apply.
        There are 13 matches and 3 choices each match:
      </p>
      <ol>
        <li>Team A Win</li>
        <li>Draw</li>
        <li>Team B Win</li>
      </ol>
      <p>
        <strong>NOTE:</strong> Svenska Spel uses 1= Team A win; x = Draw; 2 = Team B win. Soccer fans betting in South Africa, however, must use 1 = Team A win;
        2 = Draw; 3 = Team B win.
      </p>
      <p>
        All results based on score at end of 90 minutes. If a match kicks off before the pool closes or is not completed normally, it is NOT declared null and
        void. Instead the result is determined by a random computer draw from 16 possibilities – 10 soccer experts each give a result, plus two of each of the
        three possible outcomes go into the draw.
      </p>

      <div className="row">
        <div className="large-6 columns">
          <div className="panel">
            <h2>Saturday Soccer 13</h2>
            <ul>
              <li>Average Pool R20 Million!</li>
              <li>Average Pay Out R2 Million</li>
              <li>If only 1 ticket has all 13 correct - guaranteed R10-million pay out! </li>
            </ul>
            <strong>There are four chances to win in every pool!</strong>
            <p>
              All 13 correct = 40% of pool
              <br />
              Average payout R1.98 million{" "}
            </p>
            <p>
              Any 12 correct = 15% of pool
              <br />
              Average payout R9,000
            </p>
            <p>
              Any 11 correct = 12% of pool
              <br />
              Average payout R485
            </p>
            <p>
              Any 10 correct = 25% of pool
              <br />
              Average payout R110
            </p>
            <p>
              <strong>NOTE:</strong> Other 8% of pool goes to guarantee R10 million pay out in event of only one winner.
            </p>
          </div>
        </div>
        <div className="large-6 columns">
          <div className="panel">
            <h2>Sunday and Weekday Soccer 13</h2>
            <strong>There are four chances to win in every pool!</strong>
            <p>
              All 13 correct = 39% of pool
              <br />
              Average payout R507,311
            </p>
            <p>
              Any 12 correct = 22% of pool
              <br />
              Average payout R9,621
            </p>
            <p>
              Any 11 correct = 12% of pool
              <br />
              Average payout R317
            </p>
            <p>
              Any 10 correct = 25% of pool
              <br />
              Average payout R74
            </p>
            <p>
              <strong>NOTE:</strong> Other 2% of pool goes to Jackpot fund.{" "}
            </p>
          </div>
        </div>
      </div>
      <h2>Closing Times of Pools</h2>
      <p>
        All Soccer 13 pools will close in South Africa 120 minutes before the official closing time. This is because all Soccer 13 bets in South Africa are
        collated into a single batch by TAB and sent to Svenska Spel to be commingled into the host pool. Should TAB be unable to deliver the batch to Svenska
        Spel because of a communications breakdown or any other reason, all bets will be declared null and void and refunded.
      </p>
      <h2>Unit of Betting & Other Info</h2>
      <p>The unit of betting is R2.00 but this changes according to the exchange rate.</p>
      <p>Permutations of multiple entries can be played in the normal way.</p>
      <p>If any payout is R15 or less, the money is not paid out and instead carried forward to a future pool.</p>
    </div>
  );
};

export default Soccer13Rules;
